<template>
    <div class="widget">
        <vuestic-modal
            :show.sync="modalInfo.show"
            v-bind:force="true"
            ref="modalInfo"
            :cancelText="$t('modal.cancel')"
            :okText="$t('firewall.remove')"
            @ok="confirmDeleteFirewall(modalInfo.firewall)"
        >
            <div slot="title">{{ modalInfo.title }}</div>
            <div>{{ modalInfo.body }}</div>
        </vuestic-modal>
        <div class="widget-header">
            {{$t('firewall.firewalls')}}
        </div>
        <div class="widget-body">
            <div class="d-flex flex-md-row flex-column align-items-center justify-content-md-between">
                <router-link id="createFirewall" class="btn btn-primary btn-sm dropdown-toggle" type="button" :to="'/firewalls/new'">
                    {{$t('firewall.create_firewall')}}
                </router-link>
            </div>
            <table class="table table-striped first-td-padding">
                <thead>
                    <tr>
                        <td>{{$t('firewall.name')}}</td>
                        <td class="td-option">{{$t('firewall.options')}}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in firewalls" :id="key" :key="key">
                        <td>{{ item.name }}</td>
                        <td>
                            <router-link
                                :to="`/firewalls/${item.id}`"
                                class="btn btn-primary btn-micro btn-with-icon rounded-icon"
                            >
                                <div class="btn-with-icon-content">
                                    <i class="ion-md-create ion"></i>
                                </div>
                            </router-link>
                            <button
                                @click="deleteFirewall(item)"
                                class="btn btn-primary btn-micro btn-with-icon rounded-icon">
                                <i class="ion ion-md-close" style="margin-left: 3px;"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { getAxios } from 'services/ajax'
import store from '../../store'

export default {
    data () {
        return {
            firewalls: [],
            modalInfo: {
                show: true,
                firewall: null,
                title: this.$t('firewall.delete_firewall'),
                body: this.$t('firewall.delete_firewall_confirm'),
            }
        }
    },
    mounted () {
      store.commit('setLoading', true)
        getAxios().get('/configuration/firewall/list')
            .then(response => {
                this.firewalls = response.data
                
            })
            .catch(err => {
                if (err.response) {
                    console.log(err)
                }
            })
            .finally(response => store.commit('setLoading', false))
    },
    methods: {
        deleteFirewall (firewall) {
            this.modalInfo.firewall = firewall
            this.$refs.modalInfo.open()
        },
        
        confirmDeleteFirewall (firewall) {
            store.commit('setLoading', true)
            getAxios().delete(`/configuration/firewall/${firewall.id}`)
                .then(response => {
                    this.firewalls = this.firewalls.filter(f => f.id !== firewall.id)
                    this.showToast(this.$t('firewall.delete_firewall_success'), {
                        icon: 'fa-remove',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })
                }).catch(err => {
                    if (err.response) {
                        console.log(err)
                        this.showToast(this.$t('firewall.error'), {
                            icon: 'fa-remove',
                            position: 'top-center',
                            duration: 5000,
                            fullWidth: false
                        })
                    }
                })
                .finally((response) => store.commit('setLoading', false))
        }
    }
}
</script>
<style>
.td-option {
    width: 100px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/firewalls/Firewalls.vue